import * as React from "react";
const SvgDoubleCircleLine = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M10.401 6.5a6 6 0 1 0 0 11 1 1 0 1 0-.8-1.833 4 4 0 1 1 0-7.335 1 1 0 0 0 .8-1.832m5.6-.5a6 6 0 1 1 0 12 6 6 0 0 1 0-12m0 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8", clipRule: "evenodd" }));
export default SvgDoubleCircleLine;
